import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {CheckCircleOutlined, DeleteOutlined, EditFilled, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {Button, Popconfirm} from "antd";
import {useApi} from "../provider/ApiProvider";
import {useEffect, useState} from 'react';
import PlatformDialog from "../dialogs/PlatformDialog";
import RoleDialog from "../dialogs/RoleDialog";


export default function RolesPage(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Kod',
            dataIndex: 'code',
            key: 'code',
        },

        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id, record)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                </div>
            )
        }

    ];

    const {api} = useApi();
    const [dialog, setDialog] = useState({open: false, data: null});
    const [roles, setRoles] = useState({totalCount: 0, items:[]});


    useEffect(() => {
        load({skip: 0, max: 10});

    }, [])

    async function load(params){
        api.get('/roleRouter/role/all', params).then(resp => {
            setRoles({totalCount: resp.totalCount, items: resp.data})
        })
    }

    function addDialog(){
        setDialog({open: true, data: null});
    }

    function editDialog(data){
        setDialog({open: true, data: data});
    }

    function deleteRow(id, record){
        api.delete("/roleRouter/role/delete/" + id).then(resp => {
            load();
        }).finally(() => {

        })
    }



    return (
        <LayoutComponent title={"Roller"} links={
            [
                {
                    title: 'Rol listesi',
                    url: '/'
                },

            ]}
                         newButton={<>
                             <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary">Ekle</Button>
                         </>}
        >
            <TableComponent
                columns={columns}
                data={roles}
                clickAddButton={() => addDialog()}
                clickRow={(data) => editDialog(data)}
            />
            <RoleDialog
                open={dialog.open}
                data={dialog.data}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null})}
            />
        </LayoutComponent>
    )
}
